
  import React from "react"
  import Component from "/opt/build/repo/src/layouts/room-green.js"
  import data from "/opt/build/repo/.cache/json/layout-room-green.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/room-green.js